import React from 'react';

interface ErrorMessageProps {
  error: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ error }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 'var(--spacing-8)',
      flexDirection: 'column',
      gap: 'var(--spacing-4)',
    }}
  >
    <div style={{ fontSize: 'var(--font-size-24)' }}>⚠️</div>
    <p style={{ color: 'var(--color-error)' }}>Error: {error}</p>
  </div>
);
